import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ede82dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidenav-icon" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "9",
  cy: "7",
  r: "4"
}, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" }, null, -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "3",
    width: "7",
    height: "7"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "14",
    y: "3",
    width: "7",
    height: "7"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "14",
    y: "14",
    width: "7",
    height: "7"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "14",
    width: "7",
    height: "7"
  })
], -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "22.08",
    x2: "12",
    y2: "12"
  })
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })
], -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "1",
    y: "4",
    width: "22",
    height: "16",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "1",
    y1: "10",
    x2: "23",
    y2: "10"
  })
], -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
], -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "7",
    y1: "7",
    x2: "7.01",
    y2: "7"
  })
], -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "7.5",
    cy: "15.5",
    r: "5.5"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 12l8-8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M17 4h3v3" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15 6l3 3" })
], -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 640 640",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M240 160L240 224L400 224L400 160C400 115.8 364.2 80 320 80C275.8 80 240 115.8 240 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224zM400 272L240 272L240 272L192 272L192 272C183.2 272 176 279.2 176 288L176 512C176 520.8 183.2 528 192 528L448 528C456.8 528 464 520.8 464 512L464 288C464 279.2 456.8 272 448 272L448 272L400 272L400 272zM280 300C291 300 300 309 300 320L300 340L340 340L340 320C340 309 349 300 360 300C371 300 380 309 380 320L380 340L400 340C411 340 420 349 420 360C420 371 411 380 400 380L380 380L380 420L400 420C411 420 420 429 420 440C420 451 411 460 400 460L380 460L380 480C380 491 371 500 360 500C349 500 340 491 340 480L340 460L300 460L300 480C300 491 291 500 280 500C269 500 260 491 260 480L260 460L240 460C229 460 220 451 220 440C220 429 229 420 240 420L260 420L260 380L240 380C229 380 220 371 220 360C220 349 229 340 240 340L260 340L260 320C260 309 269 300 280 300zM300 380L300 420L340 420L340 380L300 380z" })
], -1 /* HOISTED */))
const _hoisted_16 = { class: "sidenav-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.to,
    class: _normalizeClass(["sidenav-item", { active: _ctx.active }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createCommentVNode(" 고객 아이콘 "),
        (_ctx.icon === 'customers')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_7))
          : (_ctx.icon === 'dashboard')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" 대시보드 아이콘 "),
                _hoisted_8
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : (_ctx.icon === 'products')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode(" 상품 아이콘 "),
                  _hoisted_9
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (_ctx.icon === 'subscription')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createCommentVNode(" 구독 아이콘 "),
                    _hoisted_10
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : (_ctx.icon === 'payment')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createCommentVNode(" 결제 아이콘 "),
                      _hoisted_11
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : (_ctx.icon === 'channels')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createCommentVNode(" 채널 연동 아이콘 "),
                        _hoisted_12
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    : (_ctx.icon === 'promotion')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createCommentVNode(" 프로모션 아이콘 (tag/percent) "),
                          _hoisted_13
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                      : (_ctx.icon === 'password')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            _createCommentVNode(" 암호 아이콘 "),
                            _hoisted_14
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : (_ctx.icon === 'security')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createCommentVNode(" 보안 아이콘 "),
                              _hoisted_15
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.text), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to", "class"]))
}